ACC.checkout = {
    spinner: $("<img id='taxesEstimateSpinner' src='" + ACC.config.resource.spinner + "' />"),

    initCustomerReference: function () {
        var $customerReference = $('#customer_reference');
        if ($customerReference.length) {
            ACC.checkout.updateCustomerReference($customerReference.get(0));
        }
    },
    initMerchantOrderComment: function () {
        $('.js-merchantOrderComment').each(function () {
            ACC.checkout.updateHiddenComment(this);
        });
    },
    initEntryReferences: function () {
        $('.entry-reference-input').each(function () {
            ACC.checkout.updateEntryReference(this);
        });
    },

    bindAll: function () {
        this.handelTextareaError();
        this.fillCustomerInput();
        this.validateVoucherInput();
        this.bindVoucherForm();
        this.bindOrderComments();
    },
    bindVoucherForm: function () {
        var $voucherForm = $('#placeVoucherForm');
        var voucherContainer = $('#voucher-container');
        $voucherForm.ajaxForm({
            success: function (cartResult, statusText, xhr, formElement) {
                if (cartResult == 'NOT_READY') {
                    $(KMVP.masterCarts.calculationInformationBoxSelector).data('status', 'NOT_READY');;
                    KMVP.masterCarts.showCartCalculationInfoBox();
                    setTimeout(KMVP.masterCarts.isCalculateOrRecalculateForSessionCartInProgressChecker, KMVP.masterCarts.poolingRequestInterval, voucherContainer);
                    console.log('Setting timeout to check, if the price calculation is ready.');
                    return;
                }
                var jsOrderColumnsId = '#js-order-columns';
                var $jsOrderColumns = $(jsOrderColumnsId);
                $jsOrderColumns.html($(cartResult).find(jsOrderColumnsId).html());
                ACC.checkoutB2B.refresh();
                KMVP.tooltips.bindTooltips($jsOrderColumns);
                ACC.checkout.bindVoucherForm();
                //Invalidate hidden fields after voucher submit
                ACC.checkout.initCustomerReference();
                ACC.checkout.initEntryReferences();
            }
        });
    },
    bindOrderComments: function () {
        $(document).on('change', '#customer_reference', function () {
            ACC.checkout.updateCustomerReference(this);
            ACC.checkout.saveCustomerReference(this);
        });

        $(document).on('change', '.entry-reference-input', function () {
        	ACC.checkout.updateEntryReference(this);
        	ACC.checkout.saveEntryReference(this);
        });

        // Only for contracts
        $(document).on('change', '[name="requestedDeliveryDate"]', function () {
            $('#hiddenRequestedDeliveryDate').val($(this).val());
        });

        $(document).on('keyup paste', '.js-merchantOrderComment', function () {
        	ACC.checkout.updateHiddenComment(this);
        });

        $(document).on('keypress', '.js-merchantOrderComment', function (event) {
            // if only one more character is allowed, prevent newline, as it is send as two characters '\r\n'
            if ((event.keyCode === 10 || event.keyCode === 13) && $(this).val().length + 2 > $(this).attr('maxlength')) {
                event.preventDefault();
            }
        });

        $(document).on('change', '.js-merchantOrderComment', function (event) {
            ACC.checkout.saveMerchantOrderComment(this);
        });
    },
    saveCustomerReference: function (inputElement) {
        var url = $(inputElement).data('url');
        var cartCode = $(inputElement).data('cartcode');
        var customerReferenceCode = $(inputElement).val();
        $.post(url,
            {
                'cartCode': cartCode,
                'customerReferenceCode': customerReferenceCode
            },
            function (data, status) {
                // do nothing
            });
    },
    saveEntryReference: function (inputElement) {
        var url = $(inputElement).data('url');
        var referenceText = $(inputElement).val();
        var entryNumberStr = $(inputElement).data('entrynumber');
        var strArr = entryNumberStr.split("_");
        var masterCartType = $(inputElement).data('cart-type');
        if (strArr.length != 2) {
            return;
        }
        var entryNumber = strArr[1];
        var cartCode = strArr[0];
        $.post(url,
            {
                'cartCode': cartCode,
                'entryNumber': entryNumber,
                'referenceText': referenceText,
                'masterCartType': masterCartType
            });
    },
    saveMerchantOrderComment: function (inputElement) {
        	var url = $(inputElement).data('url');
        	var cartCode = $(inputElement).data('cartcode');
        	var customerComment = $(inputElement).val();
        	$.post(url,
        	    {
        			'cartCode': cartCode,
        	        'comment': customerComment
        	    },
        	    function (data, status) {
        	        // do nothing
        	    });
    },

    handelTextareaError: function () {
        var error = $('#orderDetails').closest('.controls').next('.help-inline').detach();
        if (error.length) {
            error.insertAfter('.note-wishes-textarea');
            $('.note-wishes-textarea').css('border', '1px solid red');
        }
    },
    fillCustomerInput: function () {
    	var replaceCustomerReference = !$('#customer_reference').val() || $('#customer_reference').val().trim() === "";
    	var triggerCustomerReferenceChangeEvent = false;
    	if (replaceCustomerReference) {
    		$('#customer_reference').val($('#hiddenReference').val());
    		triggerCustomerReferenceChangeEvent = true;
    	}

        $('#comment').val($('#orderDetails').val());
        if ($('#hiddenReference-voucher').val()) {
            $('#customer_reference').val($('#hiddenReference-voucher').val());
            triggerCustomerReferenceChangeEvent = true;
            $('#comment').val($('#orderDetails-voucher').val());
        }
        if (triggerCustomerReferenceChangeEvent) {
        	$('#customer_reference').trigger("change");
    	}
        $('#comment').trigger("change");
    },
    validateVoucherInput: function () {
        $('#placeVoucherForm button').on('click', function () {
            var voucher = $('#placeVoucherForm .input-checkout-voucher').val();

            if (voucher.length > 0) {
                return true;
            }
            return false;
        });
    },
    changeQuoteDivInformation: function () {
        //set current date
        var today = new Date();
        $('#today').html(today.toLocaleDateString());
    },

    updateHiddenComment: function (commentElement) {
    	var comment = $(commentElement).val();
        var max = 255;

        var idString = $(commentElement).attr('id');
        var merchantId = idString.substr(idString.indexOf("_") + 1);

        // we have to count \n twice, because browsers will send \n as \r\n, but the \r is not counted for maxlength in some browsers
        // so we could send more than 255 characters to the backend
        var count = 0;
        var nLWithoutCRCount = 0; // new line without carriage return
        for (var i = 0; i < comment.length; i++) {
            if (comment[i] == '\n' && (i == 0 || comment[i - 1] != '\r')) {
                count += 2;
                nLWithoutCRCount++;
            } else {
                count++;
            }

            if (count >= max) {
                $(commentElement).val(comment.substr(0, count > max ? i : i + 1));
                break;
            }
        }

        $(commentElement).attr('maxlength', max - nLWithoutCRCount);

        $('#merchantOrderId_hidden_' + merchantId).val(merchantId);
        $('#merchantOrderComment_hidden_' + merchantId).val($(commentElement).val());
    },
    updateEntryReference: function (referenceElement) {
    	var id = $(referenceElement).data('entrynumber');
        var value = $(referenceElement).val();
        $('#orderEntryComment_comment_' + id).val(value);
    },
    updateCustomerReference: function(customerReferenceElement) {
    	$('#hiddenReference').val($(customerReferenceElement).val());
        $('#hiddenReference-voucher').val($(customerReferenceElement).val());
    }
};

$(document).ready(function () {
    ACC.checkout.initCustomerReference();
    ACC.checkout.initMerchantOrderComment();
    ACC.checkout.initEntryReferences();
    ACC.checkout.bindAll();
    ACC.checkout.changeQuoteDivInformation();
});
